import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";
import { get } from "react-hook-form";
import MyLabel from "./MyLabel";

const DiscountValidation = ({
  title,
  name,
  register,
  trigger,
  errors,
  setValue,
  placeholder,
  required,
  min,
  max,
  disabled,
  pattern,
  patternMsg,
  readonly = false,
  validate, // Add validate prop for custom validation functions
  minNum,   // Add minNum for numeric minimum validation
  maxNum,   // Add maxNum for numeric maximum validation
}) => {
  const error = get(errors, name);
  
  // Build validation rules
  const validationRules = {
    required: required
      ? {
          value: true,
          message: `${title || name} is required`,
        }
      : false,
  };

  // Add pattern validation if provided
  if (pattern) {
    validationRules.pattern = {
      value: pattern,
      message: patternMsg || `Invalid ${title || name} format`,
    };
  }

  // Add min length validation if provided
  if (min) {
    validationRules.minLength = {
      value: min,
      message: `${title || name} must be at least ${min} characters`,
    };
  }

  // Add max length validation if provided
  if (max) {
    validationRules.maxLength = {
      value: max,
      message: `${title || name} must be at most ${max} characters`,
    };
  }

  // Add numeric min validation if provided
  if (minNum !== undefined) {
    validationRules.min = {
      value: minNum,
      message: `${title || name} must be at least ${minNum}`,
    };
  }

  // Add numeric max validation if provided
  if (maxNum !== undefined) {
    validationRules.max = {
      value: maxNum,
      message: `${title || name} must be at most ${maxNum}`,
    };
  }

  // Add custom validate function if provided
  if (validate) {
    validationRules.validate = validate;
  }

  return (
    <div className="form-group ">
      <MyLabel name={name} title={title} required={required} />
      <div className="form-control-wrap">
        <input
          placeholder={placeholder}
          type="text"
          id={name}
          {...register(name, validationRules)}
          className={`form-control ${error ? "is-invalid" : ""}`}
          onChange={(e) => {
            setValue(name, e.target.value, { shouldValidate: true });
            if (trigger) trigger(name);
          }}
          readOnly={readonly}
          disabled={disabled}
        />
        {error && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {error.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default DiscountValidation;